var map = {
	"./nav-list.de-CH.json": 1028,
	"./nav-list.de-DE.json": 1029,
	"./nav-list.en-CA.json": 1030,
	"./nav-list.en-GB.json": 1031,
	"./nav-list.en-IN.json": 1032,
	"./nav-list.en-ME.json": 1033,
	"./nav-list.en-US.json": 1034,
	"./nav-list.es-EM.json": 1035,
	"./nav-list.es-ES.json": 1036,
	"./nav-list.fr-BE.json": 1037,
	"./nav-list.fr-CA.json": 1038,
	"./nav-list.fr-CH.json": 1039,
	"./nav-list.nl-BE.json": 1040,
	"./nav-list.nl-NL.json": 1041,
	"./nav-list.pl-PL.json": 1042,
	"./nav-list.pt-BR.json": 1043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1027;